import {
  FilterFieldKey,
  FilterRule,
  UNARY_OPERATORS,
} from './InfluencerList.filterTypes';
import { ServerRule } from '../model/InfluencerList.types';
import { toDateRange } from './InfluencerList.viewModel.mappers';

const DAY_MS = 86_400_000;

const inRange = (
  field: FilterFieldKey,
  range: { from: number; to: number },
): ServerRule[] => [
  { field, operator: 'gt', value: String(range.from - 1) },
  { field, operator: 'lt', value: String(range.to) },
];

const isComplete = (rule: FilterRule) =>
  rule.value != null || UNARY_OPERATORS.includes(rule.operator);

const toServerRule = (rule: FilterRule, now: Date): ServerRule[] => {
  const { field, operator, value } = rule;

  switch (operator) {
    case 'this-month':
    case 'last-month': {
      const range = toDateRange(operator, now);
      return range ? inRange(field, range) : [];
    }
    case 'last-n-days':
      return inRange(field, {
        from: Math.round(now.getTime() - Number(value) * DAY_MS),
        to: now.getTime(),
      });
    case 'before':
      return [{ field, operator: 'lt', value: String(value) }];
    case 'after':
      return [{ field, operator: 'gt', value: String(value) }];
    case 'exists':
    case 'not-exists':
      return [{ field, operator, value: null }];
    default:
      return [{ field, operator, value: String(value) }];
  }
};

// Half-built rules (binary operator, no value yet) are dropped rather than sent,
// the server rejects a binary operator with a null value.
export const toServerRules = (rules: FilterRule[], now: Date): ServerRule[] =>
  rules.filter(isComplete).flatMap((rule) => toServerRule(rule, now));
